export default __webpack_public_path__ + "static/media/SIP_AGC_Logo_2022.07e23527.png";